import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import './App.css';
import Dashboard from './Dashboard.jsx';
import KnowledgeGaps from './components/KnowledgeGaps';
import Requests from './components/Requests';
import Messages from './components/Messages';
import Reservations from './components/Reservations';
import KnowledgeBase2 from './components/KnowledgeBase2';
import Settings from './components/Settings';
import Login from './pages/Login.jsx';
import { AuthProvider, useAuth } from './state/auth.jsx';
import reportWebVitals from './reportWebVitals';

function ProtectedRoute({ children }) {
  const { accessToken } = useAuth();
  if (!accessToken) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}>
            <Route index element={<Navigate to="/knowledge_gaps" replace />} />
            <Route path="knowledge_gaps" element={<KnowledgeGaps />} />
            <Route path="requests" element={<Requests />} />
            <Route path="messages" element={<Messages />} />
            <Route path="reservations" element={<Reservations />} />
            <Route path="knowledge_base" element={<KnowledgeBase2 />} />
            <Route path="settings/*" element={<Settings />} />
            <Route path="*" element={<div className="p-10 text-red-500">Page Not Found</div>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);

reportWebVitals();

